/**
 * utilities
 * @version 2.7
 */


/**
 * @function append_children removes child nodes of element
 * @param {Node} parent - Parent Node to add child nodes too
 * @param {NodeList} node_list - List of child nodes to add
 * @return {Node}
 */
const append_children = (parent, node_list) =>
{
    const children = Array.from(node_list);

    while (children.length)
    {
        parent.appendChild(children.shift());
    }
    return parent;
};

/**
 * @function check if browser is Internet Explorer
 */
const checkIfIE = () =>
{
    var ua = window.navigator.userAgent;
    var old_ie = ua.indexOf('MSIE ');
    var new_ie = ua.indexOf('Trident/');
    return (old_ie > -1 || new_ie > -1);
    // return true;
};

/**
 * @function deep clone an object
 * @param {object} obj - object to clone
 */
const deepCloneObject = (obj) =>
{
    return JSON.parse(JSON.stringify(obj));
};

/**
 * @function filter_by_function filters an array of objects using a function
 * @param {Array} array - array of objects to filter
 * @param {Function} func - function to use to filter array of objects
 * @return {Array}
 */
const filter_by_function = (array, func) =>
{
    return array.filter(func);
};

/**
 * @function fire_when_event_ends execute function when event ends
 * @param {Function} cb - function to execute every after event
 * @param {Number} delay - sets the delay after the event ends to execute the callback
 * @return {Function}
 */
const fire_when_event_ends = (cb, delay = 50) =>
{
    let to;

    return (e) =>
    {
        if (to)
        {
            clearTimeout(to);
        }
        to = setTimeout(cb, delay, e);
    }
};

/**
* @class to generate social links based upon the metadata in the head.
* add data-social="network" (network being 'facebook, 'twitter' or 'linkedin') to the <a> element you wish for that link to be added to.
* when the class is instantiated, the links will be generated and added to the href of that <a> element.
*/
class GenerateSocialLinks
{
    constructor()
    {
        this.meta = {
            url: document.querySelector('[property="og:url"]'),
            description: document.querySelector('[property="og:description"]'),
            handle: document.querySelector('[name="twitter:site"]')
        }
        this.links = {
            facebook: `https://www.facebook.com/sharer/sharer.php?u=`,
            twitter: `https://twitter.com/intent/tweet?url=`,
            linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=`
        }

        this.encodeAll();
        this.getTargets();
        this.setSocialLinks();
    }

    /**
    * @method encode a string to a URI component
    * @param {string} string - string to encode
    */
    encode(string)
    {
        //if handle with @ symbol, remove the @
        string = (string.indexOf('@') === -1) ? string : string.split('@')[1];
        return encodeURIComponent(string);
    }

    /**
    * @method loop and encode all the metadata
    */
    encodeAll() {
        this.encoded = {};
        for (const m in this.meta)
        {
            let item = this.meta[m];
            this.encoded[m] = item ? this.encode(item.getAttribute('content')) : false;
        }
    }

    /**
     * @method loop and encode all the metadata
     */
    generateSocialLink(network)
    {
        let link = this.encoded.url ? this.links[network] + this.encoded.url : this.throwError('GenerateSocialLinks: no url for social links in metadata');
        if(network === 'facebook') {
            return link;
        }

        let param = (network === 'twitter') ? '&text=' : '&summary=';
        link = this.encoded.description ? link + param + this.encoded.description : link;
        if(network === 'linkedin') {
            return link;
        }

        link = this.encoded.handle ? link + '&via=' + this.encoded.handle : link;
        return link;
    }

    /**
     * @method get targets (element's with data-social attribute) to add the links to.
     */
    getTargets() {
        this.targets = {};
        for (const l in this.links)
        {
            let target = document.querySelector(`[data-social="${l}"]`)
            target ? this.targets[l] = target : false;
        }
    }

    /**
     * @method loop targets and set href on each to the genreated social link
     */
    setSocialLinks()
    {
        for (const t in this.targets)
        {
            this.targets[t].setAttribute('href', this.generateSocialLink(t))
        }
    }

    /**
     * @method throw error
     * @param {string} message - error message
     */
    throwError(message)
    {
        throw new Error(message);
    }
}


/**
 * @function get_object filters an array of objects
 * @param {Array} array - array of objects to filter
 * @param {String} object_prop - object property to filter by
 * @param {Number || String} object_value- character to split string by
 * @return {Array} - contains object with matching ID
 */
const get_object = (array, object_prop, object_value) =>
{
    return array.filter((object) =>
    {
        return object[object_prop] == object_value;
    });
};

/**
 * @function remove_children removes child nodes of element
 * @param {Node} parent - Parent Node with child nodes to remove
 * @return {Node}
 */
const remove_children = (parent) =>
{
    while (parent.firstChild)
    {
        parent.removeChild(parent.firstChild);
    }
    return parent;
};

/**
 * @function set value of attribute
 * @param {string} attribute - attribute name
 * @param {string} value - value to assign
 * @param {string} specificTarget - query selector to only change a specific target
 */
const set_attr = (attribute, value, specificTarget) =>
{
    attribute = (attribute.indexOf('data-') === -1) ? 'data-' + attribute : attribute;
    const targets = document.querySelectorAll(specificTarget ? `${specificTarget}[${attribute}]` : `[${attribute}]`);
    for (const t of targets)
    {
        t.setAttribute(attribute, value);
    }
};

/**
 * @function split_string_by - splits a string by the seperator passed
 * @param {String} string - String to format
 * @param {String} seperator - character to splt string by
 * @return {String} - formatted string
 */
const split_string_by = (string, seperator) =>
{
    return string.split(seperator).join(' ');
};

/**
 * Smooth Scroll - scroll to the top of an element in a smooth manner (cross browser compatible)
 * @param {string} scrollContainer - container the scroll is to be applied to:
 * Query Selector (e.g '#target, '.target', '[attribute]' etc) of scroll container.
 * OPTIONAL - defaults to body.
 *
 * @param {string} target - Query Selector (e.g '#target, '.target', '[attribute]' etc) of target to scroll to.
 * OPTIONAL - will only scroll offset distance from current scroll position if not included.
 *
 * @param {number} offsetDistance - distance to scroll in addition to distance to target.
 * If no target, this is the total scroll distance.
 * OPTIONAL - defaults to 0.
 *
 * @param {number} duration - duration of scroll animation.
 * OPTIONAL - defaults to 1000ms.
 *
 * @param {boolean} horizontalScroll - scroll along the x axis.
 * OPTIONAL - defaults to false.
 *
 * @param {string} easeType - name of easetype animation, relates to a prop in the easings object.
 * OPTIONAL - defaults to 'exponentialInOut'.
 *
 * @param {boolean} backToTop - scroll to top of scrollContainer. Overrides any targets, but offsetDistance will still apply.
 * E.g if offsetDistance is 500, it will scroll to 500px from the top.
 * OPTIONAL - defaults to false.
 */
const smooth_scroll = ({scrollContainer, target, offsetDistance = 0, horizontalScroll = false, duration = 1000, easeType = 'exponentialInOut', backToTop = false}) =>
{
    let position = {};
    scrollContainer = !scrollContainer ? false : (scrollContainer === 'body') ? false : document.querySelector(scrollContainer);

    if (horizontalScroll)
    {
        position.start = scrollContainer ? scrollContainer.scrollLeft : window.pageXOffset;
    }
    else
    {
        position.start = scrollContainer ? scrollContainer.scrollTop : window.pageYOffset;
    }

    if (target)
    {
        target = document.querySelector(target);
        if (horizontalScroll)
        {
            position.target = scrollContainer ? target.offsetLeft - scrollContainer.getBoundingClientRect().left : target.getBoundingClientRect().left;
        }
        else
        {
            position.target = scrollContainer ? target.offsetTop - scrollContainer.getBoundingClientRect().top : target.getBoundingClientRect().top;
        }
        offsetDistance = backToTop ? offsetDistance : scrollContainer ? (position.target - position.start) + offsetDistance : position.target + offsetDistance;
    }

    offsetDistance = backToTop ? (position.start * -1) + offsetDistance : offsetDistance;

    let startTime;

    function scrollAnimation(currentTime)
    {
        startTime = startTime ? startTime : currentTime;
        const timeElapsed = currentTime - startTime;
        const scroll = easings[easeType](timeElapsed, position.start, offsetDistance, duration);

        if (horizontalScroll)
        {
            scrollContainer ? scrollContainer.scrollLeft = scroll : window.scrollTo(scroll, 0);
        }
        else
        {
            scrollContainer ? scrollContainer.scrollTop = scroll : window.scrollTo(0, scroll);
        }

        (timeElapsed < duration) ? requestAnimationFrame(scrollAnimation) : false;
    }

    requestAnimationFrame(scrollAnimation);
};

/**
 * easing animations
 */
const easings = {
    linear: function (t, b, c, d)
    {
        return ((c * (t / d)) + b);
    },
    quadIn: function (t, b, c, d)
    {
        t /= d;
        return ((c * t * t) + b);
    },
    quadOut: function (t, b, c, d)
    {
        t /= d;
        return ((-c * t * (t - 2)) + b);
    },
    quadInOut: function (t, b, c, d)
    {
        t /= d / 2;
        if (t < 1)
        {
            return (((c / 2) * t * t) + b);
        }
        t--;
        return (((-c / 2) * ((t * (t - 2)) - 1)) + b);
    },
    cubicIn: function (t, b, c, d)
    {
        t /= d;
        return ((c * t * t * t) + b);
    },
    cubicOut: function (t, b, c, d)
    {
        t /= d;
        t--;
        return ((c * ((t * t * t) + 1)) + b);
    },
    cubicInOut: function (t, b, c, d)
    {
        t /= d / 2;
        if (t < 1)
        {
            return (((c / 2) * t * t * t) + b);
        }
        t -= 2;
        return (((c / 2) * ((t * t * t) + 2)) + b);
    },
    quarticIn: function (t, b, c, d)
    {
        t /= d;
        return ((c * t * t * t * t) + b);
    },
    quarticOut: function (t, b, c, d)
    {
        t /= d;
        t--;
        return (-c * ((t * t * t * t) - 1)) + b;
    },
    quarticInOut: function (t, b, c, d)
    {
        t /= d / 2;
        if (t < 1)
        {
            return (((c / 2) * t * t * t * t) + b);
        }
        t -= 2;
        return (((-c / 2) * ((t * t * t * t) - 2)) + b);
    },
    quinticIn: function (t, b, c, d)
    {
        t /= d;
        return ((c * t * t * t * t * t) + b);
    },
    quinticOut: function (t, b, c, d)
    {
        t /= d;
        t--;
        return ((c * ((t * t * t * t * t) + 1)) + b);
    },
    quinticInOut: function (t, b, c, d)
    {
        t /= d / 2;
        if (t < 1)
        {
            return (((c / 2) * t * t * t * t * t) + b);
        }
        t -= 2;
        return (((c / 2) * ((t * t * t * t * t) + 2)) + b);
    },
    sinusoidalIn: function (t, b, c, d)
    {
        return ((-c * Math.cos(t / d * (Math.PI / 2))) + c + b);
    },
    sinusoidalOut: function (t, b, c, d)
    {
        return ((c * Math.sin(t / d * (Math.PI / 2))) + b);
    },
    sinusoidalInOut: function (t, b, c, d)
    {
        return (((-c / 2) * (Math.cos(Math.PI * t / d) - 1)) + b);
    },

    exponentialIn: function (t, b, c, d)
    {
        return ((c * Math.pow(2, 10 * ((t / d) - 1))) + b);
    },
    exponentialOut: function (t, b, c, d)
    {
        return ((c * (-Math.pow(2, -10 * t / d) + 1)) + b);
    },
    exponentialInOut: function (t, b, c, d)
    {
        t /= d / 2;
        if (t < 1)
        {
            return (((c / 2) * Math.pow(2, 10 * (t - 1))) + b);
        }
        t--;
        return (((c / 2) * (-Math.pow(2, -10 * t) + 2)) + b);
    },

    circularIn: function (t, b, c, d)
    {
        t /= d;
        return ((-c * (Math.sqrt(1 - (t * t)) - 1)) + b);
    },
    circularOut: function (t, b, c, d)
    {
        t /= d;
        t--;
        return ((c * Math.sqrt(1 - (t * t))) + b);
    },
    circularInOut: function (t, b, c, d)
    {
        t /= d / 2;
        if (t < 1)
        {
            return (((-c / 2) * (Math.sqrt(1 - (t * t)) - 1)) + b);
        }
        t -= 2;
        return (((c / 2) * (Math.sqrt(1 - (t * t)) + 1)) + b);
    }
};

/**
 * @function stringify_data - change all props (or specific props) in data to strings
 * @param {object} data - data to stringify
 * @param {boolean} createNewVariable - will return new array rather than mutating the data that's passed if true.
 * OPTIONAL - defaults to false (will edit the original data variable passed rather than return a new variable).
 * @param {string || array} specificProps - specific props to target, can be an array or string (each prop seperated by a space).
 * OPTIONAL - will change all props in the data if not passed.
 */
const stringify_data = (data, createNewVariable, specificProps) =>
{
    if (specificProps && (typeof specificProps === 'string'))
    {
        specificProps = specificProps.split(' ');
    }

    let newArray;
    newArray = createNewVariable ? [] : false;
    for (const obj of data)
    {
        let assign;
        assign = newArray ? {} : obj;
        for (const prop in obj)
        {
            if (typeof obj[prop] === 'number')
            {
                if (specificProps)
                {
                    if (specificProps.indexOf(prop) !== -1)
                    {
                        assign[prop] = obj[prop].toString();
                    }
                    else
                    {
                        assign[prop] = obj[prop];
                    }
                }
                else
                {
                    assign[prop] = obj[prop].toString();
                }
            }
        }
        newArray ? newArray = [...newArray, assign] : false;
    }

    return newArray;

};

/**
 * @function throttle throttle EventListners by defferring payload
 * @param {Function} cb - function to execute every x interval
 * @param {Number} delay - sets the execution intervals
 * @return {Function}
 */
const throttle = (cb, delay = 200) =>
{

    let wait_for_it = false;


    return (e) =>
    {
        if (!wait_for_it)
        {
            cb(e);
            wait_for_it = true;
            setTimeout(() =>
            {
                wait_for_it = false;
            }, delay);
        }
    }
};

/**
 * @class allow to toggle between true/false on props held in a 'current' object, which are then reflected in document under data attributes (i.e data-prop)
 * @param {obj} currentObj - obj that holds the boolean props.
 * @param {boolean} value - if true, ensure all the data attributes in the document match the props in the 'current' object. OPTIONAL - defaults to true.
 */
class Toggle
{
    constructor(currentObj, matchOnSetup = true, delegateEvents = true)
    {
        this.current = currentObj ? currentObj : {};

        if (delegateEvents)
        {
            let toggles = document.querySelectorAll('[data-toggle]');
            for (const t of toggles)
            {
                const self = this;
                const target = t.getAttribute('data-toggle');
                t.addEventListener('click', function ()
                {
                    self.switch(target);
                })

                if (!this.current.hasOwnProperty(target))
                {
                    let value = self.getFirstValue(target);
                    this.current[target] = value ? (value === 'true') : false;
                    if (!value)
                    {
                        console.warn(`no defined value for ${target} found, so it has been set to false as default`)
                    }
                }
            }
        }

        if (matchOnSetup)
        {
            for (const item in this.current)
            {
                set_attr(item, this.current[item]);
            }
        }

    }

    getFirstValue(target)
    {
        const elements = document.querySelectorAll(`[data-${target}`);
        for (const e of elements)
        {
            let value = e.getAttribute(`data-${target}`);
            if (value)
            {
                return value;
            }
        }
        return false;
    }

    /**
     * @method toggle prop stored in current variable and apply to data-attribute on page
     * @param {string} prop - prop to target in 'current' object. REQUIRED.
     * @param {boolean} forceClose - force set prop to false. OPTIONAL
     * @param {string} specificTarget - query selector to only change a specific target (extended from set_attr). OPTIONAL
     */
    switch(prop, forceClose, specificTarget)
    {
        if (this.current.hasOwnProperty(prop))
        {
            this.current[prop] = forceClose ? false : !this.current[prop];
        }
        else
        {
            const target = document.querySelector(`[data-${prop}]`);
            if (target)
            {
                const value = target.getAttribute(`data-${prop}`);
                this.current[prop] = forceClose ? false : (value === 'false');
            }
            else
            {
                console.warn(`utils/toggle: no ${prop} in 'current' object or document`);
                return false;
            }
        }

        set_attr(prop, this.current[prop], specificTarget);
    }

    /**
     * @method throw error
     * @param {string} message - error message
     */
    throwError(message)
    {
        throw new Error(message);
    }
}

// ************************************</editor-fold>
// EXPORTS
// ************************************<editor-fold>
// module.exports = {append_children, checkIfIE, deepCloneObject, filter_by_function, fire_when_event_ends, get_object, remove_children, set_attr, split_string_by, smooth_scroll, easings, stringify_data, throttle, Toggle};
// export {
//     append_children,
//     checkIfIE,
//     deepCloneObject,
//     filter_by_function,
//     fire_when_event_ends,
//     get_object,
//     GenerateSocialLinks,
//     remove_children,
//     set_attr,
//     split_string_by,
//     smooth_scroll,
//     easings,
//     stringify_data,
//     throttle,
//     Toggle
// }
